module.exports = __webpack_public_path__ + "static/media/logo_premiaciones_b.5f16157d.png";